import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "task-panel" }
const _hoisted_2 = { class: "task-panel__header" }
const _hoisted_3 = { class: "task-panel__body" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row info-row justify-content-between" }
const _hoisted_7 = { class: "col-8" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "row info-row justify-content-between" }
const _hoisted_10 = { class: "col-8" }
const _hoisted_11 = {
  key: 0,
  class: "value"
}
const _hoisted_12 = { class: "row info-row justify-content-between" }
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "col-8" }
const _hoisted_16 = {
  key: 0,
  class: "value"
}
const _hoisted_17 = { class: "row info-row justify-content-between" }
const _hoisted_18 = { class: "col-8" }
const _hoisted_19 = {
  key: 0,
  class: "value"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "row info-row justify-content-between" }
const _hoisted_22 = { class: "col-4" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "col-8" }
const _hoisted_25 = {
  key: 0,
  class: "value"
}
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "row info-row justify-content-between" }
const _hoisted_28 = { class: "col-8 info-value-cell" }
const _hoisted_29 = { class: "verification-tooltip" }
const _hoisted_30 = { class: "verification-tooltip__header" }
const _hoisted_31 = { class: "verification-tooltip__label" }
const _hoisted_32 = { class: "verification-tooltip__desc" }
const _hoisted_33 = {
  key: 1,
  class: "email-display-single"
}
const _hoisted_34 = {
  key: 2,
  class: "email-dropdown-menu"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "verification-tooltip" }
const _hoisted_37 = { class: "verification-tooltip__header" }
const _hoisted_38 = { class: "verification-tooltip__label" }
const _hoisted_39 = { class: "verification-tooltip__desc" }
const _hoisted_40 = {
  key: 1,
  class: "info-value-empty"
}
const _hoisted_41 = { class: "row info-row justify-content-between" }
const _hoisted_42 = { class: "col-8 info-value-cell" }
const _hoisted_43 = {
  key: 1,
  class: "phone-display-single"
}
const _hoisted_44 = {
  key: 2,
  class: "phone-dropdown-menu"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 1,
  class: "info-value-empty"
}
const _hoisted_47 = { class: "row info-row justify-content-between" }
const _hoisted_48 = { class: "col-8 info-value-cell" }
const _hoisted_49 = {
  key: 0,
  class: "value"
}
const _hoisted_50 = { style: {"color":"#6b7280","font-size":"11px","white-space":"nowrap"} }
const _hoisted_51 = {
  key: 1,
  class: "info-value-empty"
}
const _hoisted_52 = { class: "action-bar" }
const _hoisted_53 = { class: "row form-row-tight" }
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "col" }
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = { class: "row form-row-tight" }
const _hoisted_59 = { class: "col" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = { class: "col" }
const _hoisted_62 = { class: "form-group" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { class: "d-flex justify-content-between align-items-center next-task-note-row" }
const _hoisted_65 = { class: "task-panel__footer" }
const _hoisted_66 = { class: "task-panel__footer-buttons" }

import { Icon } from "@iconify/vue";
import { Clipboard } from "v-clipboard";
import { v4 as uuidv4 } from "uuid";
import { Button, DateSelector, RichTextEditor, Select } from "@/components/ui";
import { ErrorMessage, Form } from "vee-validate";
import { TaskType } from "@/utils/enums";
import { getTaskTypeIcon } from "@/utils/iconMapping";
import { COMPANY_OVERVIEW_ROUTE, CONTACT_OVERVIEW_ROUTE } from "@/router/routes";
import { useContactData } from "@/composables/contacts/useContactData";
import { useBucketOptions } from "@/composables/bucket/useBucketOptions";
import { useBucketLockStatus } from "@/composables/bucket/useBucketLockStatus";
import { useUploadDraftNoteAttachment, useDeleteNoteDraftAttachments } from "@/composables/notes";
import { ref, computed, watch, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import { useToast } from "@/composables/ui/useToast";
import { useFormDraft } from "@/composables/shared";
import { useStore } from "vuex";
import { formatTimezone, getCurrentTimeInTimezone } from "@/utils/timezone";
import { getEmailVerificationIcon } from "@/utils/emailVerificationStatus";
import type { ContactBucketSummary } from "@/dtos/Bucket.dto";
import { useRouter } from "vue-router";

interface Props {
  selectedBucket: {
    id?: string | null;
    taskType?: string | null;
    followUpDate?: string | null;
    bucketOptionId?: string | null;
    note?: string | null;
    contact?: {
      id?: string;
      fname?: string;
      lname?: string;
      jobTitle?: string;
      email?: string;
      linkedInUrl?: string;
      timezone?: string;
      company?: {
        id?: string;
        name?: string;
        website?: string;
        linkedInUrl?: string;
      };
    };
  };
  contact?: {
    id?: string;
    fname?: string;
    lname?: string;
    jobTitle?: string;
    email?: string;
    linkedInUrl?: string;
    timezone?: string;
    phones?: Array<any>;
    emails?: Array<any>;
    company?: {
      id?: string;
      name?: string;
      website?: string;
      linkedInUrl?: string;
    };
    bucket?: ContactBucketSummary | null;
  } | null;
  bucketIsLoading?: boolean;
  bucketOptions?: Array<{ id: string; name: string }>;
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: "NextTaskFollowupModal",
},
  __name: 'NextTaskFollowupModal',
  props: {
    selectedBucket: {},
    contact: { default: null },
    bucketIsLoading: { type: Boolean, default: false },
    bucketOptions: { default: () => [] }
  },
  emits: ["close", "save", "show-notes-modal", "show-last-interaction-modal", "show-edit-contact-modal", "show-book-meeting-modal", "show-linkedin-profile-modal", "show-company-profile-modal"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const instance = getCurrentInstance();
const $toast = useToast();
const $filters = instance?.proxy && (instance.proxy as any).$filters;
const router = useRouter();

// Store
const store = useStore();
const account = computed(() => store.getters.account.data);
const organizationId = computed(() => account.value?.organizationId);

// State
const editBucketObj = ref({
  id: undefined as string | undefined,
  taskType: undefined as string | undefined,
  followUpDate: undefined as string | undefined,
  bucketOptionId: undefined as string | undefined,
  note: undefined as string | undefined,
});

const selectedFollowUpOption = ref<string | undefined>(undefined);

// This note isn't a persisted entity until the bucket itself is saved (see handleSubmit),
// so uploads have nowhere to attach to yet — route them through the same client-generated
// draftKey used by NotesModal.vue's unsaved-note flow, which just needs a grouping key.
//
// Unlike NotesModal.vue, there's no backend support for linking a draft's attachments to
// a Bucket/Task note (NoteAttachment only has a noteId, not a bucketId) — so a saved note's
// embedded file link has no server-side record tying it to the note that references it.
// What we CAN still guarantee from here: never leave an upload orphaned when the user backs
// out without saving. hasSubmitted marks "a save was attempted with this draftKey" so we
// never discard an attachment that might already be embedded in a persisted note — we only
// clean up drafts that were never submitted at all.
const draftKey = ref<string | null>(null);
const pendingUploads = ref(0);
let hasSubmitted = false;
const uploadDraft = useUploadDraftNoteAttachment();
const discardDraft = useDeleteNoteDraftAttachments();

const discardAbandonedDraft = () => {
  if (!draftKey.value || hasSubmitted) return;
  discardDraft.mutate(draftKey.value, { onError: () => {} });
  draftKey.value = null;
};

// Shared with NotesModal.vue's "Add Note" form — both are just different entry
// points for jotting an unsaved note about the same contact, so they read/write
// the same draft under a common contact-scoped key.
const { loadDraft: loadNoteTextDraft, clearDraft: clearNoteTextDraft } = useFormDraft(
  editBucketObj,
  {
    key: `contact-note-draft:${props.contact?.id}`,
    serialize: (v) => ({ text: v.note ?? "" }),
    isEmpty: (v) => !v.text?.trim(),
  }
);

const handleEditorUpload = async (payload: {
  file: File;
  kind: "image" | "video" | "file";
  placeholderId?: string;
  signal?: AbortSignal;
  onProgress?: (pct: number) => void;
  onSuccess?: (url: string) => void;
  onError?: (msg?: string) => void;
}) => {
  try {
    if (!draftKey.value) draftKey.value = uuidv4();
    const result = await uploadDraft.mutateAsync({
      draftKey: draftKey.value,
      files: [payload.file],
      onProgress: payload.onProgress,
      signal: payload.signal,
    });
    const uploaded = result?.[0];
    if (uploaded?.url && payload.onSuccess) {
      payload.onSuccess(uploaded.url);
    } else {
      payload.onError?.("Upload failed");
    }
  } catch (err: any) {
    if (err?.code === "ERR_CANCELED" || err?.name === "AbortError") return;
    payload.onError?.(err?.message || "Upload failed");
  }
};

// Bucket options query
const bucketOptionsParams = computed(() => {
  if (!organizationId.value) return null;
  return {
    organizationId: organizationId.value,
  };
});

const { data: bucketOptionsData } = useBucketOptions(bucketOptionsParams);

// Bucket lock status query
const bucketLockParams = computed(() => {
  if (!organizationId.value) return null;
  return {
    organizationId: organizationId.value,
    offset: new Date().getTimezoneOffset(),
  };
});
const { data: bucketLockStatusData } = useBucketLockStatus(bucketLockParams);

// Get set of locked bucket IDs
const lockedBucketIds = computed(() => {
  if (!bucketLockStatusData.value?.enabled) return new Set<string>();
  return new Set(
    bucketLockStatusData.value.bucketStatuses
      .filter((s: any) => s.isLocked && !s.hasOverride)
      .map((s: any) => s.bucketOptionId)
  );
});

// Computed properties
const contactPhoneNumbers = computed(() => {
  const { computeContactPhoneNumbers } = useContactData(store);
  return computeContactPhoneNumbers({ contact: props.contact });
});

const contactEmails = computed(() => {
  const { computeContactEmails } = useContactData(store);
  return computeContactEmails({ contact: props.contact });
});

const taskTypeOptions = computed(() => {
  return Object.values(TaskType).map((task) => ({
    value: task,
    label: $filters?.capitalize?.(task) || task,
    icon: getTaskTypeIcon(task),
  }));
});

const bucketOptionsFormatted = computed(() => {
  const options = bucketOptionsData.value || props.bucketOptions || [];
  return options.map((bucket: any) => {
    const isLocked = lockedBucketIds.value.has(bucket.id);
    return {
      value: bucket.id,
      label: isLocked ? `🔒 ${bucket.name} (Locked)` : bucket.name,
      disabled: isLocked,
      icon: "fa6-solid:bucket",
      iconColor: bucket.colorHex,
    };
  });
});

const followUpOnOptions = [
  { value: "1", label: "Follow Up Tomorrow" },
  { value: "3", label: "Follow Up In 3 Days" },
  { value: "7", label: "Follow Up In 1 Week" },
  { value: "14", label: "Follow Up In 2 Weeks" },
  { value: "30", label: "Follow Up In 1 Month" },
  { value: "60", label: "Follow Up In 2 Months" },
  { value: "90", label: "Follow Up In 3 Months" },
  { value: "180", label: "Follow Up In 6 Months" },
  { value: "365", label: "Follow Up In 1 Year" },
];

// Methods
const closeModal = () => {
  discardAbandonedDraft();
  emit("close");
};

// This modal is mounted globally (see App.vue), so router-link navigation alone
// doesn't unmount it — we navigate first, then explicitly close it once the
// route change has gone through.
const goToContactOverview = async () => {
  const contactId = props.contact?.id;
  if (!contactId) return;
  await router.push({ name: CONTACT_OVERVIEW_ROUTE, params: { id: contactId } });
  closeModal();
};

const goToCompanyOverview = async () => {
  const companyId = props.contact?.company?.id;
  if (!companyId) return;
  await router.push({ name: COMPANY_OVERVIEW_ROUTE, params: { id: companyId } });
  closeModal();
};

const openInNewTab = (url: string | undefined | null) => {
  if (url) window.open(url, "_blank");
};

const emailDropdownOpen = ref(false);
const phoneDropdownOpen = ref(false);
const emailDropdownRef = ref<HTMLElement | null>(null);
const phoneDropdownRef = ref<HTMLElement | null>(null);

const toggleEmailDropdown = () => {
  emailDropdownOpen.value = !emailDropdownOpen.value;
  phoneDropdownOpen.value = false;
};

const togglePhoneDropdown = () => {
  phoneDropdownOpen.value = !phoneDropdownOpen.value;
  emailDropdownOpen.value = false;
};

const handleClickOutside = (e: MouseEvent) => {
  if (emailDropdownRef.value && !emailDropdownRef.value.contains(e.target as Node)) {
    emailDropdownOpen.value = false;
  }
  if (phoneDropdownRef.value && !phoneDropdownRef.value.contains(e.target as Node)) {
    phoneDropdownOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("mousedown", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("mousedown", handleClickOutside);
  discardAbandonedDraft();
});

const copyToClipboard = (value: string | undefined | null) => {
  if (!value) return;
  Clipboard.copy(value);
  $toast?.info("Copied to clipboard");
};

const updateFollowUpDate = () => {
  if (!selectedFollowUpOption.value) return;
  const daysToAdd = parseInt(selectedFollowUpOption.value, 10);
  const target = new Date();
  target.setDate(target.getDate() + daysToAdd);
  const localMidnight = new Date(
    target.getFullYear(),
    target.getMonth(),
    target.getDate(),
    0,
    0,
    0,
    0
  );
  editBucketObj.value.followUpDate = localMidnight.toISOString();
};

const handleSubmit = () => {
  hasSubmitted = true;
  clearNoteTextDraft();
  emit("save", editBucketObj.value);
};

// The task itself may not have a bucketOptionId stamped on it (e.g. it predates
// the contact being auto-bucketed), so fall back to the contact's live bucket.
const contactBucketOptionId = computed(
  () => props.contact?.bucket?.bucketOptionId ?? props.contact?.bucket?.bucketOption?.id
);

// Lifecycle
onMounted(() => {
  if (props.selectedBucket) {
    editBucketObj.value.id = props.selectedBucket.id ?? undefined;
    editBucketObj.value.taskType = props.selectedBucket.taskType ?? undefined;
    editBucketObj.value.followUpDate = props.selectedBucket.followUpDate ?? undefined;
    editBucketObj.value.bucketOptionId =
      props.selectedBucket.bucketOptionId ?? contactBucketOptionId.value ?? undefined;
    editBucketObj.value.note = props.selectedBucket.note ?? undefined;
  }
  const draft = loadNoteTextDraft();
  if (draft?.text?.trim()) {
    editBucketObj.value.note = draft.text;
  }
});

// The contact's bucket data loads asynchronously (after this modal mounts), so
// backfill once it arrives if the task didn't already have a bucket selected.
watch(contactBucketOptionId, (newVal) => {
  if (newVal && !editBucketObj.value.bucketOptionId) {
    editBucketObj.value.bucketOptionId = newVal;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_VTooltip = _resolveComponent("VTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "task-panel__header-text" }, [
        _createElementVNode("h6", { class: "task-panel__title" }, "Next Task And Follow-Up"),
        _createElementVNode("p", { class: "task-panel__subtitle" }, "Schedule your next outreach action")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        class: "task-panel__close-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal())),
        "aria-label": "Close"
      }, [
        _createVNode(_unref(Icon), {
          icon: "mdi:close",
          width: "18",
          height: "18"
        })
      ])
    ]),
    _createVNode(_unref(Form), {
      class: "form",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-4" }, [
                  _createElementVNode("h6", { class: "title" }, "Name")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h6", _hoisted_8, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "link",
                      onClick: _withModifiers(goToContactOverview, ["prevent"])
                    }, _toDisplayString(_unref($filters)?.capitalize?.(__props.contact?.fname) || __props.contact?.fname) + " " + _toDisplayString(_unref($filters)?.capitalize?.(__props.contact?.lname) || __props.contact?.lname), 1),
                    _createVNode(_unref(Icon), {
                      icon: "mdi:content-copy",
                      class: "action-icon-btn",
                      width: "16",
                      height: "16",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(`${__props.contact?.fname || ''} ${__props.contact?.lname || ''}`)))
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col-4" }, [
                  _createElementVNode("h6", { class: "title" }, "Title")
                ], -1)),
                _createElementVNode("div", _hoisted_10, [
                  (__props.contact?.jobTitle)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_11, [
                        _createTextVNode(_toDisplayString(__props.contact?.jobTitle) + " ", 1),
                        _createVNode(_unref(Icon), {
                          icon: "mdi:content-copy",
                          class: "action-icon-btn",
                          width: "16",
                          height: "16",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (copyToClipboard(__props.contact?.jobTitle)))
                        })
                      ]))
                    : (_openBlock(), _createBlock(_unref(Icon), {
                        key: 1,
                        icon: "mdi:minus",
                        width: "16",
                        height: "16",
                        style: {"color":"#9ca3af"}
                      }))
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h6", _hoisted_14, [
                    _cache[27] || (_cache[27] = _createTextVNode(" Company ", -1)),
                    (__props.contact?.company?.linkedInUrl)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "linkedin-view-btn",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('show-company-profile-modal'))),
                          title: "View company LinkedIn profile"
                        }, [
                          _createVNode(_unref(Icon), {
                            icon: "mdi:linkedin",
                            class: "linkedin-view-icon"
                          }),
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "linkedin-view-text" }, "View", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (__props.contact?.company)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_16, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "link",
                          onClick: _withModifiers(goToCompanyOverview, ["prevent"])
                        }, _toDisplayString(__props.contact?.company?.name), 1),
                        _createVNode(_unref(Icon), {
                          icon: "mdi:content-copy",
                          class: "action-icon-btn",
                          width: "16",
                          height: "16",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (copyToClipboard(__props.contact?.company?.name)))
                        })
                      ]))
                    : (_openBlock(), _createBlock(_unref(Icon), {
                        key: 1,
                        icon: "mdi:minus",
                        width: "16",
                        height: "16",
                        style: {"color":"#9ca3af"}
                      }))
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-4" }, [
                  _createElementVNode("h6", { class: "title" }, "Website")
                ], -1)),
                _createElementVNode("div", _hoisted_18, [
                  (__props.contact?.company?.website)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_19, [
                        _createElementVNode("a", {
                          class: "link",
                          href: 
                      _unref($filters)?.normalizeWebsite?.(__props.contact?.company?.website) ||
                      __props.contact?.company?.website
                    ,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, _toDisplayString(__props.contact?.company?.website), 9, _hoisted_20),
                        _createVNode(_unref(Icon), {
                          icon: "mdi:open-in-new",
                          class: "action-icon-btn",
                          width: "16",
                          height: "16",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (
                      openInNewTab(
                        _unref($filters)?.normalizeWebsite?.(__props.contact?.company?.website) ||
                          __props.contact?.company?.website
                      )
                    ), ["stop"]))
                        }),
                        _createVNode(_unref(Icon), {
                          icon: "mdi:content-copy",
                          class: "action-icon-btn",
                          width: "16",
                          height: "16",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (copyToClipboard(__props.contact?.company?.website)), ["stop"]))
                        })
                      ]))
                    : (_openBlock(), _createBlock(_unref(Icon), {
                        key: 1,
                        icon: "mdi:minus",
                        width: "16",
                        height: "16",
                        style: {"color":"#9ca3af"}
                      }))
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h6", _hoisted_23, [
                    _cache[30] || (_cache[30] = _createTextVNode(" LinkedIn ", -1)),
                    (__props.contact?.linkedInUrl)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "linkedin-view-btn",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('show-linkedin-profile-modal'))),
                          title: "View LinkedIn profile"
                        }, [
                          _createVNode(_unref(Icon), {
                            icon: "mdi:linkedin",
                            class: "linkedin-view-icon"
                          }),
                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "linkedin-view-text" }, "View", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (__props.contact?.linkedInUrl)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_25, [
                        _createElementVNode("a", {
                          class: "link",
                          href: __props.contact?.linkedInUrl,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, _toDisplayString(__props.contact?.linkedInUrl), 9, _hoisted_26),
                        _createVNode(_unref(Icon), {
                          icon: "mdi:open-in-new",
                          class: "action-icon-btn",
                          width: "16",
                          height: "16",
                          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (openInNewTab(__props.contact?.linkedInUrl)), ["stop"]))
                        }),
                        _createVNode(_unref(Icon), {
                          icon: "mdi:content-copy",
                          class: "action-icon-btn",
                          width: "16",
                          height: "16",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (copyToClipboard(__props.contact?.linkedInUrl)), ["stop"]))
                        })
                      ]))
                    : (_openBlock(), _createBlock(_unref(Icon), {
                        key: 1,
                        icon: "mdi:minus",
                        width: "16",
                        height: "16",
                        style: {"color":"#9ca3af"}
                      }))
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-4" }, [
                  _createElementVNode("h6", { class: "title" }, "Email")
                ], -1)),
                _createElementVNode("div", _hoisted_28, [
                  (contactEmails.value && contactEmails.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        ref_key: "emailDropdownRef",
                        ref: emailDropdownRef,
                        class: "email-dropdown value"
                      }, [
                        _createVNode(_component_VTooltip, null, {
                          popper: _withCtx(() => [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_unref(Icon), {
                                  icon: 
                              _unref(getEmailVerificationIcon)(contactEmails.value[0]?.verificationStatus).icon
                            ,
                                  width: "16",
                                  height: "16",
                                  style: _normalizeStyle({
                              color: _unref(getEmailVerificationIcon)(contactEmails.value[0]?.verificationStatus)
                                .color,
                            })
                                }, null, 8, ["icon", "style"]),
                                _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(getEmailVerificationIcon)(contactEmails.value[0]?.verificationStatus).label), 1)
                              ]),
                              _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(getEmailVerificationIcon)(contactEmails.value[0]?.verificationStatus)
                              .description), 1)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(Icon), {
                              icon: _unref(getEmailVerificationIcon)(contactEmails.value[0]?.verificationStatus).icon,
                              width: "14",
                              height: "14",
                              style: _normalizeStyle([{"cursor":"pointer"}, {
                        color: _unref(getEmailVerificationIcon)(contactEmails.value[0]?.verificationStatus).color,
                      }])
                            }, null, 8, ["icon", "style"])
                          ]),
                          _: 1
                        }),
                        (contactEmails.value.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn email-dropdown-toggle",
                              type: "button",
                              onClick: toggleEmailDropdown
                            }, [
                              _createTextVNode(_toDisplayString(contactEmails.value[0]?.email) + " ", 1),
                              _createVNode(_unref(Icon), {
                                icon: "mdi:chevron-down",
                                class: "email-chevron",
                                width: "14",
                                height: "14"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(contactEmails.value[0]?.email), 1)),
                        _createVNode(_unref(Icon), {
                          icon: "mdi:content-copy",
                          class: "email-copy-icon",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (copyToClipboard(contactEmails.value[0]?.email))),
                          title: "Copy email"
                        }),
                        (contactEmails.value.length > 1 && emailDropdownOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactEmails.value, (emailObj, index) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: index,
                                  type: "button",
                                  class: "email-dropdown-item",
                                  onClick: ($event: any) => (copyToClipboard(emailObj?.email))
                                }, [
                                  _createVNode(_component_VTooltip, null, {
                                    popper: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                          _createVNode(_unref(Icon), {
                                            icon: _unref(getEmailVerificationIcon)(emailObj?.verificationStatus).icon,
                                            width: "16",
                                            height: "16",
                                            style: _normalizeStyle({
                                  color: _unref(getEmailVerificationIcon)(emailObj?.verificationStatus)
                                    .color,
                                })
                                          }, null, 8, ["icon", "style"]),
                                          _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(getEmailVerificationIcon)(emailObj?.verificationStatus).label), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(getEmailVerificationIcon)(emailObj?.verificationStatus).description), 1)
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Icon), {
                                        icon: _unref(getEmailVerificationIcon)(emailObj?.verificationStatus).icon,
                                        width: "14",
                                        height: "14",
                                        style: _normalizeStyle([{"cursor":"pointer","flex-shrink":"0"}, {
                            color: _unref(getEmailVerificationIcon)(emailObj?.verificationStatus).color,
                          }])
                                      }, null, 8, ["icon", "style"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("span", null, _toDisplayString(emailObj?.email), 1),
                                  _createVNode(_unref(Icon), {
                                    icon: "mdi:content-copy",
                                    class: "email-dropdown-item-icon"
                                  })
                                ], 8, _hoisted_35))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 512))
                    : (_openBlock(), _createElementBlock("span", _hoisted_40, "—"))
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-4" }, [
                  _createElementVNode("h6", { class: "title" }, "Phone Numbers")
                ], -1)),
                _createElementVNode("div", _hoisted_42, [
                  (contactPhoneNumbers.value && contactPhoneNumbers.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        ref_key: "phoneDropdownRef",
                        ref: phoneDropdownRef,
                        class: "phone-dropdown value"
                      }, [
                        (contactPhoneNumbers.value.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn phone-dropdown-toggle",
                              type: "button",
                              onClick: togglePhoneDropdown
                            }, [
                              _createTextVNode(_toDisplayString(_unref($filters)?.formatPhoneNumber?.(contactPhoneNumbers.value[0]?.number) ||
                      contactPhoneNumbers.value[0]?.number) + " ", 1),
                              _createVNode(_unref(Icon), {
                                icon: "mdi:chevron-down",
                                class: "phone-chevron",
                                width: "14",
                                height: "14"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_unref($filters)?.formatPhoneNumber?.(contactPhoneNumbers.value[0]?.number) ||
                      contactPhoneNumbers.value[0]?.number), 1)),
                        _createVNode(_unref(Icon), {
                          icon: "mdi:content-copy",
                          class: "phone-copy-icon",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (copyToClipboard(contactPhoneNumbers.value[0]?.number))),
                          title: "Copy number"
                        }),
                        (contactPhoneNumbers.value.length > 1 && phoneDropdownOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactPhoneNumbers.value, (phoneNumber, index) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: index,
                                  type: "button",
                                  class: "phone-dropdown-item",
                                  onClick: ($event: any) => (copyToClipboard(phoneNumber?.number))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(_unref($filters)?.formatPhoneNumber?.(phoneNumber?.number) || phoneNumber?.number), 1),
                                  _createVNode(_unref(Icon), {
                                    icon: "mdi:content-copy",
                                    class: "phone-dropdown-item-icon"
                                  })
                                ], 8, _hoisted_45))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 512))
                    : (_openBlock(), _createElementBlock("span", _hoisted_46, "—"))
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-4" }, [
                  _createElementVNode("h6", { class: "title" }, "Timezone")
                ], -1)),
                _createElementVNode("div", _hoisted_48, [
                  (__props.contact?.timezone)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_49, [
                        _createVNode(_unref(Icon), {
                          icon: "mdi:clock-outline",
                          width: "14",
                          height: "14",
                          style: {"color":"#6b7280","flex-shrink":"0"}
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(formatTimezone)(__props.contact?.timezone)) + " ", 1),
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(getCurrentTimeInTimezone)(__props.contact?.timezone)), 1),
                        _createVNode(_unref(Icon), {
                          icon: "mdi:content-copy",
                          class: "action-icon-btn",
                          width: "16",
                          height: "16",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (
                      copyToClipboard(
                        __props.contact?.timezone
                          ? `${_unref(formatTimezone)(__props.contact.timezone)} — ${_unref(getCurrentTimeInTimezone)(__props.contact.timezone)}`
                          : ''
                      )
                    ))
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_51, "—"))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_unref(Button), {
              type: "button",
              variant: "outline",
              size: "xs",
              class: "btn-outline-primary",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('show-last-interaction-modal')))
            }, {
              default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                _createTextVNode(" Last Interaction History ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              type: "button",
              variant: "primary",
              size: "xs",
              class: "btn-edit-rounded",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('show-edit-contact-modal')))
            }, {
              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                _createTextVNode(" Edit ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_unref(Select), {
                  modelValue: editBucketObj.value.bucketOptionId,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((editBucketObj.value.bucketOptionId) = $event)),
                  options: bucketOptionsFormatted.value,
                  label: "Bucket",
                  required: true
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_unref(Select), {
                  modelValue: editBucketObj.value.taskType,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editBucketObj.value.taskType) = $event)),
                  options: taskTypeOptions.value,
                  label: "Task Type",
                  required: true
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_unref(Select), {
                  modelValue: selectedFollowUpOption.value,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((selectedFollowUpOption).value = $event)),
                  options: followUpOnOptions,
                  label: "Follow up on",
                  placeholder: "Select follow up option",
                  onChange: updateFollowUpDate
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_unref(DateSelector), {
                  modelValue: editBucketObj.value.followUpDate,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((editBucketObj.value.followUpDate) = $event)),
                  label: "Follow up date",
                  "disable-past": false,
                  required: true
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _cache[37] || (_cache[37] = _createElementVNode("label", {
                for: "message",
                class: "next-task-note-label"
              }, "Add Note", -1)),
              _createVNode(_unref(Button), {
                type: "button",
                variant: "outline",
                size: "xs",
                class: "btn-outline-primary",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('show-notes-modal')))
              }, {
                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                  _createTextVNode(" Notes History ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createVNode(_unref(RichTextEditor), {
              ref: "noteEditor",
              modelValue: editBucketObj.value.note,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((editBucketObj.value.note) = $event)),
              height: "150px",
              placeholder: "Enter here",
              onUpload: handleEditorUpload,
              onUploadsPending: _cache[21] || (_cache[21] = ($event: any) => (pendingUploads.value = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(ErrorMessage), {
              name: "message",
              class: "form-text text-danger"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_unref(Button), {
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('show-book-meeting-modal'))),
              type: "button",
              variant: "primary",
              disabled: __props.bucketIsLoading,
              block: ""
            }, {
              default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                _createTextVNode(" Book ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(Button), {
              type: "submit",
              variant: "secondary",
              loading: __props.bucketIsLoading,
              disabled: __props.bucketIsLoading || pendingUploads.value > 0,
              block: ""
            }, {
              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                _createTextVNode(" Save ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})